import { create } from 'zustand'

export interface ReportFilters {
  dateStart: string
  dateEnd: string
  projectTypes: string[]
  estimatorId: string
  clientId: string
  status: string
  isPublicWorks: string
}

const defaultFilters: ReportFilters = {
  dateStart: '',
  dateEnd: '',
  projectTypes: [],
  estimatorId: '',
  clientId: '',
  status: '',
  isPublicWorks: '',
}

interface ReportState {
  filters: ReportFilters
  cachedFilters: Record<string, ReportFilters>
  setFilter: <K extends keyof ReportFilters>(key: K, value: ReportFilters[K]) => void
  setFilters: (filters: Partial<ReportFilters>) => void
  resetFilters: () => void
  loadCacheForReport: (reportId: string) => void
  saveCacheForReport: (reportId: string) => void
}

export const useReportStore = create<ReportState>((set, get) => ({
  filters: { ...defaultFilters },
  cachedFilters: {},

  setFilter: (key, value) =>
    set((state) => ({ filters: { ...state.filters, [key]: value } })),

  setFilters: (partial) =>
    set((state) => ({ filters: { ...state.filters, ...partial } })),

  resetFilters: () => set({ filters: { ...defaultFilters } }),

  loadCacheForReport: (reportId) => {
    const cached = get().cachedFilters[reportId]
    if (cached) set({ filters: { ...cached } })
    else set({ filters: { ...defaultFilters } })
  },

  saveCacheForReport: (reportId) => {
    const { filters, cachedFilters } = get()
    set({ cachedFilters: { ...cachedFilters, [reportId]: { ...filters } } })
  },
}))
